var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFuelconsumption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 555,
    height: 138,
    viewBox: "0 0 555 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9513 45.5195C40.6852 47.5583 12.5493 22.5833 0.264648 9.84099V137.265H554.265V72.2787C540.989 63.359 512.774 45.5195 506.117 45.5195C497.795 45.5195 463.913 116.877 457.374 116.877C450.835 116.877 412.198 9.84099 401.499 0.921361C390.799 -7.99827 358.106 76.7383 348.595 85.6579C339.084 94.5775 324.818 27.6803 311.147 25.1318C297.475 22.5833 268.348 88.8435 252.299 102.223C236.25 115.602 217.228 50.6165 202.368 45.5195C187.507 40.4226 160.758 96.4889 153.031 96.4889C145.303 96.4889 115.582 9.84099 104.288 9.84099C92.9943 9.84099 72.784 42.9711 54.9513 45.5195Z",
    fill: "url(#paint0_linear_93_7362)",
    stroke: "#20DDAF",
    strokeWidth: 0.529326
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_93_7362",
    x1: 277.859,
    y1: -51.3418,
    x2: 277.176,
    y2: 137.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20DDAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelconsumption);
export default __webpack_public_path__ + "static/media/fuelconsumption.ee567085f6a61c245e7703da80734bd5.svg";
export { ForwardRef as ReactComponent };